import React from "react";
import TYPES from "./constants";

import SelectField from "./selectField/selectField.component";
import DateField from "./dateField/dateField.component";
import LocationField from "./locationField/locationField.component";

const Field = ({ type, ...props }) => {
  switch (type) {
    case TYPES.SELECT:
      return <SelectField {...props} />;
    case TYPES.DATE:
      return <DateField {...props} />;
    case TYPES.LOCATION:
      return <LocationField {...props} />;
    default:
      return <input type="text" {...props} />;
  }
};

export { TYPES };
export default Field;
